import {requireNativeViewManager} from 'expo-modules-core'
import {type ComponentType} from 'react'

import {type NativeViewProps} from './types'

const NativeView: ComponentType<NativeViewProps> = requireNativeViewManager(
  'ExpoBlueskyPeekMenu',
)

export default NativeView
